module.exports = __webpack_public_path__ + "static/contact--header@2x-8a0a02bc8dfd95fa0aca27cc399017f3.jpg";